<div class="dialog-content-wrapper edit-module-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    @if (info) {
      <span class="title dialog-title">{{info.name}}</span>
    }
    <button mat-button class="mat-icon-button"
      (click)="dialogRef.close()"
      aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  <!--    </div>-->
</mat-toolbar>
@if (info) {
  <div class="m-0 content">
    @for (module of info.matrixModule; track module) {
      @if (module.modules) {
        <div class="module">
          <div class="module-title">{{module.modules.title}}</div>
          <div>
            <mat-checkbox [(ngModel)]="module.enable"></mat-checkbox>
          </div>
        </div>
      }
    }
  </div>
}
<div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button class="mat-accent mr-16" (click)="edit()">{{'main.save' | translate}}</button>
  <button mat-button (click)="dialogRef.close(false)">{{'button.cancel' | translate}}</button>
</div>
</div>

